export * from "./Paper.settings";
